import React, { useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';

const GoogleOAuthTest = () => {
  useEffect(() => {
    console.log('🔧 Current URL:', window.location.origin);
    console.log('🔧 Current hostname:', window.location.hostname);
    console.log('🔧 Current port:', window.location.port);
    console.log('🔧 Current protocol:', window.location.protocol);
    console.log('🔧 Full location:', window.location.href);
    console.log('🔧 Google Client ID from env:', process.env.REACT_APP_GOOGLE_CLIENT_ID);
  }, []);

  const testGoogleInit = () => {
    console.log('🔧 Testing Google initialization...');
    
    if (window.google) {
      try {
        console.log('🔧 Google object available');
        console.log('🔧 Google accounts:', window.google.accounts);
        console.log('🔧 Google accounts.id:', window.google.accounts.id);
        
        // Try to initialize with detailed logging
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: (response) => {
            console.log('✅ Google callback received:', response);
          },
          auto_select: false,
          cancel_on_tap_outside: false,
        });
        
        console.log('✅ Google initialize called successfully');
        
        // Try to render button
        window.google.accounts.id.renderButton(
          document.getElementById('test-google-button'),
          {
            theme: 'outline',
            size: 'large',
            type: 'standard',
            shape: 'rectangular',
            text: 'signin_with',
            logo_alignment: 'left',
            width: 250,
          }
        );
        
        console.log('✅ Google button rendered');
        
      } catch (error) {
        console.error('❌ Google initialization error:', error);
      }
    } else {
      console.error('❌ Google object not available');
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Google OAuth Debug Test
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1">
          <strong>Current Origin:</strong> {window.location.origin}
        </Typography>
        <Typography variant="body1">
          <strong>Client ID:</strong> {process.env.REACT_APP_GOOGLE_CLIENT_ID}
        </Typography>
      </Box>

      <Button
        variant="contained"
        onClick={testGoogleInit}
        sx={{ mb: 2 }}
      >
        Test Google Initialization
      </Button>

      <Box>
        <Typography variant="h6" gutterBottom>
          Google Button Test:
        </Typography>
        <div id="test-google-button"></div>
      </Box>

      <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100' }}>
        <Typography variant="body2">
          <strong>Debug Info:</strong><br/>
          Check browser console for detailed logs.<br/>
          Make sure your Google Console has these exact origins:<br/>
          • {window.location.origin}<br/>
          • Both in "Authorized JavaScript origins" AND "Authorized redirect URIs"
        </Typography>
      </Box>
    </Box>
  );
};

export default GoogleOAuthTest;